import { useContext } from 'react';
import FormModal from '../../Shared/form/modal/FormModal';  
import { UIControlType } from '@stormwater-software/lib-form-control-types';
import { FormContext, FormSchemaFields } from '@stormwater-software/lib-form';
import reportApi from '../../../utils/api/report';
import _ from 'lodash';
import React from 'react';

import { useTerminology } from '../../../hooks/useTerminology';
import { Terms } from '@stormwater-software/lib-domain';
const getProjectOptions = (availableClients: any, selectedClients: any) => {
    const projects = availableClients.find((client: any) => Number(selectedClients) === Number(client.id))?.projects || [];
    
    return projects.sort((a: any, b: any) => a.name.localeCompare(b.name));
};

const getSchema = (formData: any, terms: Terms) => {
    const formContext = useContext(FormContext);

    const clients = formData.map((client: any) => ({ id: client.id, name: client.name }))
        .sort((a: any, b: any) => a.name.localeCompare(b.name));

    const schema: any = {
        clients: {
            controlType: UIControlType.select,
            label: terms.entity,
            options: clients,
            valueKey: 'id',
            labelKey: 'name',
            validation: { required: true },
        },
        projects: {
            controlType: UIControlType.customTagSelect,
            labelKey: 'name',
            valueKey: 'id',
            isMulti: true,
            openOnFocus: true,
            showSelectAll: true,
            label: 'Select Project(s)',
            options: getProjectOptions(formData, formContext.value.clients),
            placeholder: 'Search for projects',
            showClearAll: true,
        },
        showProjectsWithoutInspections: {
            label: "Include projects with no inspections in the selected timeframe",
            controlType: UIControlType.checkbox,
            placeholder: "Include projects with no inspections in the selected timeframe",
            "aria-label": "Include projects with no inspections in the selected timeframe",
        },
        start_date: {
            controlType: UIControlType.date,
            label: 'Start Date',
            style: { flex: '0 1 50%' },
            validation: {
                maxDate: new Date(),
                required: true,
            },
        },
        end_date: {
            controlType: UIControlType.date,
            label: 'End Date',
            style: { flex: '0 1 50%' },
            validation: {
                minDate: new Date(formContext.value.start_date).setDate(
                    new Date(formContext.value.start_date).getDate() + 1
                ),
                maxDate: new Date(
                    new Date(formContext.value.start_date).setDate(
                        new Date(formContext.value.start_date).getDate() + 6
                    )
                ),
                required: true,
            },
        },
    };

    return schema;
};

const WeeklyReportModal = ({
    setShowModal,
    setData,
    setCount,
    setFormData,
    formData,
    isEdit,
}: {
    setShowModal: Function;
    setData: Function;
    setCount: Function;
    setFormData: Function;
    formData: any;
    isEdit: boolean;
}) => {
    const formContext = useContext(FormContext);
    const terms = useTerminology();

    const submit = async () => {
        reportApi
            .getWeeklyReport({
                clientIds: formContext.value.clients,
                projectIds: formContext.value.projects && formContext.value.projects.length ? formContext.value.projects.map((p: any) => p.id) : [],
                minDate: formContext.value.start_date,
                maxDate: formContext.value.end_date,
                divisionId: formData.divisionId,
                showAll: formContext.value.showProjectsWithoutInspections,
                page: 1,
            })
            .then((data) => {
                setData(data.pageData);
                setCount(data.paginationData.numModels)
                setShowModal(false);
                setFormData("startDate", formContext.value.start_date)
                setFormData("endDate", formContext.value.end_date)
                setFormData("clients", formContext.value.clients)
                setFormData("projects", formContext.value.projects)
                setFormData("showProjectsWithoutInspections", formContext.value.showProjectsWithoutInspections)
            });
    };

    const handleClose = () => {
        setShowModal(false);
    };

    return (
        <FormModal
            onSubmit={submit}
            onCancel={handleClose}
            modalProps={{
                title: isEdit ? 'Modify Weekly Report' : 'Create Weekly Report',
                submitBtnText: 'Generate',
            }}
        >
            <section className='weekly-report-form'>
                <section className='container'>
                    <FormSchemaFields
                        schema={getSchema(formData.modalData, terms)}
                        onChange={formContext.set}
                        formData={formContext.value}
                        initialFormData={formContext.value}
                    />
                </section>
            </section>
        </FormModal>
    );
};

export default WeeklyReportModal;
